/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '@/http/requests/auth/jwt/index.js'
import router from '@/router'

export default {
  loginJWT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.login(payload.login, payload.password, payload.remember, payload.code2FA)
        .then(response => {
          // If two Factor Authentication is required
          if (response && response.status === 206) {
            reject({
              status: response.status,
              message: 'Se requiere verificación de dos pasos'
            })
          }

          // If there's user data in response
          if (response.data.user) {
            // Extract panel permissions from user.permissions array
            const allPermissions = response.data.user.permissions || []
            const perms = allPermissions.filter(perm => perm.startsWith('use_accounting_panel_') || perm === 'show_licenses')

            // Check if user has at least one panel permission
            if (perms.length === 0) {
              reject({message: 'No tienes permisos para acceder al panel'})
              return
            }

            // Set accessToken
            localStorage.setItem('accessToken', response.data.token)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.user, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.data.token)

            // Update store with global mutation
            commit('UPDATE_PANEL_PERMISSIONS', perms, {root: true})

            // Sync to localStorage
            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
            if (userInfo) {
              userInfo.panel_permissions = perms
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
            }

            // Navigate
            router.push(router.currentRoute.query.to || '/')
            resolve(response)
          } else {
            reject({message: 'No tienes permiso para acceder al panel'})
          }

        })
        .catch(error => {
          if (!!error.response && !!error.response.status && error.response.status === 400) {
            reject({message: 'Datos de acceso incorrectos'})
          }
          if (!!error.response && !!error.response.status && error.response.status === 422) {
            reject({message: 'El código es incorrecto, intenta de nuevo'})
          }
          reject(error)
        })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
